module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('scan-barcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('h3', [_vm._v("請掃描條碼以更新登入用條碼")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5e47280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserManual/Barcode.vue
// module id = 1542
// module chunks = 1